import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Fade } from "react-reveal";

import Navbar from "components/navbar/navbar";
import Footer from "components/v2/footer/footer";
import Summary from "views/v2/summary/about";
import Loading from "components/loading-animation/loading-animation";
import { changeLanguage } from "redux/actions/languageAction";
import MessageBanner from "components/message-banner/message-banner";

import { leanplumTracker } from "helpers/tracker";
import { newHandIll } from "config/assets/illustrations";
import { getCurrentYear } from "helpers/utils";
import {
  grabModalMantulBigLogo,
  purpleOVOPaylaterLogo,
  ovoModalUsahaMitraPurpleLogo,
  ovoModalUsahaPeminjamPurpleLogo,
} from "config/assets/logos";
import {
  handCoinIcon,
  walletIcon,
  handMoneyIcon,
  handHomeIcon,
} from "config/assets/icons";

import "./main.scss";

const Home = (props) => {
  const { language, statistics } = props;
  const { selected, languageData } = language;

  useEffect(() => {
    leanplumTracker("homepage", {
      Trigger: "Page Load",
      Product: "Taralite Website",
      Page: "Homepage",
      Description: "Page Load - Taralite Website - Homepage",
    });
  }, []);

  const learnMoreTracker = (value) => {
    leanplumTracker("homepage", {
      Trigger: "Card Click",
      TriggerValue: "Pelajari lebih lanjut",
      Product: "Taralite Website",
      Page: "Homepage",
      Data: { Card: value },
      Description:
        "Card Click - Pelajari lebih lanjut - Taralite Website - Homepage",
    });
  };

  const currencyText = (selectedLang, item) => {
    const isFetchSuccess =
      (selectedLang === "id" &&
        statistics[selectedLang][item] !== "Gagal memuat") ||
      (selectedLang === "en" &&
        statistics[selectedLang][item] !== "Failed to fetch");
    if (!isFetchSuccess) return "";
    if (item === "total_fee") return "%";
    switch (selectedLang) {
      case "id":
        return "Rp";
      case "en":
        return "IDR";
      default:
        break;
    }
  };

  const renderTestimonials = () => {
    const { contents } = languageData[selected].newhome.testimonial;

    return contents.map((item, index) => {
      return (
        <Fade key={index} bottom distance="50px" delay={100 * index}>
          <div className="testimony-card">
            <div className="header">{item.name}</div>
            <div className="sub-header">{item.type}</div>
            <div className="value">{item.testimony}</div>
          </div>
        </Fade>
      );
    });
  };

  return (
    <div className="new-home-container">
      <MessageBanner
        message={
          languageData[selected].newhome.warning.text
        }
      />
      <Navbar {...props} />
      <div className="homepage-intro">
        <Fade bottom distance="50px">
          <div className="intro-content">
            <h1 className="intro-heading">
              {languageData[selected].newhome.introduction.header}
            </h1>
            <div className="intro-subheading">
              {languageData[selected].newhome.introduction.subheader}
            </div>
          </div>
        </Fade>
        <Fade right distance="50px" delay={200}>
          <div className="illustration">
            <img src={newHandIll} alt="omu-illustration" />
          </div>
        </Fade>
      </div>
      <Fade bottom distance="50px" fraction={0.1}>
        <Summary language={language} />

        <div className="white-section">
          <div className="omu">
            <div className="card">
              <div className="card-detail">
                <div className="title">
                  <img
                    className="image"
                    src={grabModalMantulBigLogo}
                    alt="grab modal logo"
                    style={{ height: "30px" }}
                  />
                </div>
                <Link
                  to="/GrabModalMantul"
                  className="button"
                  onClick={() => learnMoreTracker("Mitra")}
                >
                  {languageData[selected].newhome.products.omu.label_partners}{" "}
                  <i className="fas fa-angle-right" />
                </Link>
              </div>
              <img
                className="card-icon"
                src={handCoinIcon}
                alt="hand coin icon"
              />
            </div>
            <div className="card">
              <div className="card-detail">
                <div className="title">
                  <img
                    className="image"
                    src={purpleOVOPaylaterLogo}
                    alt="OVO Paylater logo"
                  />
                </div>
                <Link
                  to="/paylater"
                  className="button"
                  onClick={() => learnMoreTracker("Mitra")}
                >
                  {languageData[selected].newhome.products.omu.label_partners}{" "}
                  <i className="fas fa-angle-right" />
                </Link>
              </div>
              <img className="card-icon" src={walletIcon} alt="Wallet icon" />
            </div>
            <div className="card">
              <div className="card-detail">
                <div className="title">
                  <img
                    className="image"
                    src={ovoModalUsahaPeminjamPurpleLogo}
                    alt="OMU logo"
                  />
                </div>
                <Link
                  to="/omu/landing/borrower"
                  className="button"
                  onClick={() => learnMoreTracker("Peminjam")}
                >
                  {languageData[selected].newhome.products.omu.label_borrowers}{" "}
                  <i className="fas fa-angle-right" />
                </Link>
              </div>
              <img
                className="card-icon"
                src={handMoneyIcon}
                alt="Web Borrower Icon"
              />
            </div>
            <div className="card">
              <div className="card-detail">
                <div className="title">
                  <img
                    className="image"
                    src={ovoModalUsahaMitraPurpleLogo}
                    alt="OMU logo"
                  />
                </div>
                <Link
                  to="/omu/landing/underlying"
                  className="button"
                  onClick={() => learnMoreTracker("Mitra")}
                >
                  {languageData[selected].newhome.products.omu.label_partners}{" "}
                  <i className="fas fa-angle-right" />
                </Link>
              </div>
              <img className="card-icon" src={handHomeIcon} alt="Bottle icon" />
            </div>
          </div>
          <Fade bottom distance="50px">
            <div className="section-portfolio">
              <div className="text">
                {languageData[selected].newhome.portfolio.label}
              </div>
              <div className="title-container">
                <div className="title">
                  {languageData[selected].newhome.portfolio.header}
                </div>
                <div className="sub-title">
                  {languageData[selected].newhome.portfolio.subheader}
                </div>
              </div>
            </div>
            <div className="statistics">
              <div className="statistics-card">
                <div className="header">
                  {languageData[selected].newhome.portfolio.total_loan.label}
                </div>
                <div className="sub-header">
                  {
                    languageData[selected].newhome.portfolio.total_loan
                      .established
                  }
                </div>
                {statistics ? (
                  <div className="value">
                    {currencyText(selected, "loan_facilitated")}{" "}
                    {statistics && statistics[selected].loan_facilitated}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
              <div className="statistics-card">
                <div className="header">
                  {languageData[selected].newhome.portfolio.total_loan.label}
                </div>
                <div className="sub-header">
                  {
                    languageData[selected].newhome.portfolio.total_loan
                      .this_year
                  }
                </div>
                {statistics ? (
                  <div className="value">
                    {currencyText(selected, "loan_facilitated_year")}{" "}
                    {statistics && statistics[selected].loan_facilitated_year}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
              <div className="statistics-card">
                <div className="header">
                  {languageData[selected].newhome.portfolio.total_loan.label}
                </div>
                <div className="sub-header">
                  {
                    languageData[selected].newhome.portfolio.total_loan
                      .outstanding
                  }
                </div>
                {statistics ? (
                  <div className="value">
                    {currencyText(selected, "total_outstanding")}{" "}
                    {statistics && statistics[selected].total_outstanding}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
              <div className="statistics-card">
                <div className="header">
                  {
                    languageData[selected].newhome.portfolio.total_borrower
                      .label
                  }
                </div>
                <div className="sub-header">
                  {
                    languageData[selected].newhome.portfolio.total_borrower
                      .overall
                  }
                </div>
                {statistics ? (
                  <div className="value">
                    {statistics && statistics[selected].total_borrower}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
              <div className="statistics-card">
                <div className="header">
                  {
                    languageData[selected].newhome.portfolio.total_borrower
                      .label
                  }
                </div>
                <div className="sub-header">
                  {
                    languageData[selected].newhome.portfolio.total_borrower
                      .active
                  }
                </div>
                {statistics ? (
                  <div className="value">
                    {statistics && statistics[selected].total_active_borrower}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
              <div className="statistics-card">
                <div className="header">
                  {
                    languageData[selected].newhome.portfolio.total_borrower
                      .label
                  }
                </div>
                <div className="sub-header">
                  {languageData[selected].newhome.portfolio.total_borrower.year}{" "}
                  {getCurrentYear()}
                </div>
                {statistics ? (
                  <div className="value">
                    {statistics && statistics[selected].total_borrower_year}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
              <div className="statistics-card">
                <div className="header">
                  {languageData[selected].newhome.portfolio.total_lender.label}
                </div>
                <div className="sub-header">
                  {
                    languageData[selected].newhome.portfolio.total_lender
                      .established
                  }
                </div>
                {statistics ? (
                  <div className="value">
                    {statistics && statistics[selected].total_lender}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
              <div className="statistics-card">
                <div className="header">
                  {languageData[selected].newhome.portfolio.total_lender.label}
                </div>
                <div className="sub-header">
                  {languageData[selected].newhome.portfolio.total_lender.active}
                </div>
                {statistics ? (
                  <div className="value">
                    {statistics && statistics[selected].total_active_lender}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
              <div className="statistics-card">
                <div className="header">
                  {languageData[selected].newhome.portfolio.total_lender.label}
                </div>
                <div className="sub-header">
                  {languageData[selected].newhome.portfolio.total_lender.year}{" "}
                  {getCurrentYear()}
                </div>
                {statistics ? (
                  <div className="value">
                    {statistics && statistics[selected].total_lender_year}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
              <div className="statistics-card">
                <div className="header">
                  {languageData[selected].newhome.portfolio.total_cost.label}
                </div>
                <div className="sub-header">
                  {languageData[selected].newhome.portfolio.total_cost.overall}
                </div>
                {statistics ? (
                  <div className="value">
                    {statistics && statistics[selected].total_fee}{" "}
                    {currencyText(selected, "total_fee")}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
            </div>
          </Fade>

          <div className="section-portfolio">
            <div className="text">
              {languageData[selected].newhome.testimonial.label}
            </div>
            <div className="title-container">
              <div className="title">
                {languageData[selected].newhome.testimonial.header}
              </div>
              <div className="sub-title">
                {languageData[selected].newhome.testimonial.subheader}
              </div>
            </div>
          </div>

          <div className="testimony">{renderTestimonials()}</div>
          <Fade bottom distance="50px">
            <div className="video-testimony">
              <a
                href="https://youtu.be/zEt6yQtwdJo"
                target="_blank"
                rel="noopener noreferrer"
              >
                {/* <button className="testimony-button hide">
                  {languageData[selected].newhome.testimonial.button}
                </button> */}
              </a>
            </div>
          </Fade>
        </div>
      </Fade>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  language: state.languageReducer,
  statistics: state.portfolioReducer.statistics,
});

const mapDispatchToProps = (dispatch) => ({
  changeLanguage: (type) => dispatch(changeLanguage(type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
